import type { TerminalI, TerminalFilterI } from 'types';
import { BaseApi } from './base-api';

class TerminalsApi extends BaseApi<TerminalI, TerminalFilterI> {}

const terminalsApi = new TerminalsApi('/terminals');

export default terminalsApi;
